import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import g from 'glamorous'
import moment from 'moment';
import 'moment-timezone-all';
import 'moment/locale/es';

import Swiper from 'react-id-swiper'
import 'react-id-swiper/src/styles/css/swiper.css'

import MatchDetail from './match-detail-fragm'
import SocialShare from './social-share-fragm'
import TeamInCard from './team-in-card-fragm'

class CardViews extends Component {
    
    constructor(props) {
      super(props)    
      this.currentMatchSlides = null
      this.currendCardIndex = null
    }

    componentDidMount() {
        this.currendCardIndex = this.props.cardIndex
        if (this.currentMatchSlides && this.currentMatchSlides.activeIndex !== this.currendCardIndex) {
            this.currentMatchSlides.slideTo(this.currendCardIndex)
        }

        let cardsViewEl = ReactDOM.findDOMNode(this)
        let scrollTo = Math.floor(cardsViewEl.getBoundingClientRect().top + document.scrollingElement.scrollTop)
        this.props.emphasysCard(scrollTo - 104)
    }

    bindElWidthCurrentMatchSlides = (node) => {
        if (node !== null) {
            this.currentMatchSlides = node.swiper
            this.currentMatchSlides.on("slideChange", () => {
                if (this.currendCardIndex !== this.currentMatchSlides.activeIndex) this.props.gotocard(this.currentMatchSlides.activeIndex)
            })
        }        
    }

    formatUTCMatchDate(datetimeUTC, format) {
        return moment(parseInt(datetimeUTC, 0)).tz(moment.tz.guess()).format(format)
    }

    render () {
        if (this.currendCardIndex !== this.props.cardIndex) {
            this.currendCardIndex = this.props.cardIndex
            if (this.currentMatchSlides && this.currentMatchSlides.activeIndex !== this.currendCardIndex) {
                this.currentMatchSlides.slideTo(this.currendCardIndex)
            }
        }        
        const {currentLeftTeam, currentRightTeam, currentMatch, defaults, currentStadium} = this.props
        const params = { 
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        }
        return (<Swiper {...params} ref={this.bindElWidthCurrentMatchSlides}>                    
                    <g.Div className="card">
                        <g.Ul display="flex"
                              justifyContent="center"
                              alignItems="center"
                              flexDirection="row">
                            <TeamInCard
                                pic={`./images/foods/${currentLeftTeam.food.pic}`}
                                name={currentLeftTeam.food.name}
                                minTxt={`${defaults.foodCalories.min}`}
                                maxTxt={`${defaults.foodCalories.max}`}
                                valueTxt={`${currentLeftTeam.food.calories} calorías`}
                                barPercent={(currentLeftTeam.food.calories/defaults.foodCalories.max)*100} />
                            <g.Li>
                                <g.Div className="content-share-detail">
                                    <SocialShare leftInfo={currentLeftTeam.food.name} rightInfo={currentRightTeam.food.name} />
                                    <MatchDetail
                                        timeTxt={this.formatUTCMatchDate(currentMatch.datetimeUTC, 'HH:mm z')}
                                        dateTxt={this.formatUTCMatchDate(currentMatch.datetimeUTC, 'DD/MM/YYYY')}
                                        stadiumTxt={`${currentStadium.name}, ${currentStadium.city}`}
                                        altTxt="" />
                                </g.Div>
                            </g.Li>
                            <TeamInCard
                                pic={`./images/foods/${currentRightTeam.food.pic}`}
                                name={currentRightTeam.food.name}
                                minTxt={`${defaults.foodCalories.min}`}
                                maxTxt={`${defaults.foodCalories.max}`}
                                valueTxt={`${currentRightTeam.food.calories} calorías`}
                                barPercent={(currentRightTeam.food.calories/defaults.foodCalories.max)*100} />
                        </g.Ul>
                    </g.Div>  
                    <g.Div className="card">
                        <g.Ul display="flex"
                              justifyContent="center"
                              alignItems="center"
                              flexDirection="row">
                            <TeamInCard
                                pic={`./images/players/${currentLeftTeam.player.pic}`}
                                name={currentLeftTeam.player.name}
                                minTxt={`€${defaults.playerEarnings.min}`}
                                maxTxt={`€${defaults.playerEarnings.max} MDE`}
                                valueTxt={`${currentLeftTeam.player.earnings} partidos oficiales`}
                                barPercent={(currentLeftTeam.player.earnings/defaults.playerEarnings.max)*100} />
                            <g.Li>
                                <g.Div className="content-share-detail">
                                    <SocialShare leftInfo={currentLeftTeam.player.name} rightInfo={currentRightTeam.player.name} />
                                    <MatchDetail
                                        timeTxt={this.formatUTCMatchDate(currentMatch.datetimeUTC, 'HH:mm z')}
                                        dateTxt={this.formatUTCMatchDate(currentMatch.datetimeUTC, 'DD/MM/YYYY')}
                                        stadiumTxt={`${currentStadium.name}, ${currentStadium.city}`}
                                        altTxt="" />
                                </g.Div>
                            </g.Li>
                            <TeamInCard
                                pic={`./images/players/${currentRightTeam.player.pic}`}
                                name={currentRightTeam.player.name}
                                minTxt={`€${defaults.playerEarnings.min}`}
                                maxTxt={`€${defaults.playerEarnings.max} MDE`}
                                valueTxt={`${currentRightTeam.player.earnings} partidos oficiales`}
                                barPercent={(currentRightTeam.player.earnings/defaults.playerEarnings.max)*100} />
                        </g.Ul>
                    </g.Div>
                    <g.Div className="card">
                        <g.Ul display="flex"
                              justifyContent="center"
                              alignItems="center"
                              flexDirection="row">
                            <TeamInCard
                                pic={`./images/beverages/${currentLeftTeam.beverage.pic}`}
                                name={currentLeftTeam.beverage.name}
                                minTxt={`${defaults.beverageAlcoholProof.min}º`}
                                maxTxt={`${defaults.beverageAlcoholProof.max}º`}
                                valueTxt={`${currentLeftTeam.beverage.alcoholProof}º de alcohol`}
                                barPercent={(currentLeftTeam.beverage.alcoholProof/defaults.beverageAlcoholProof.max)*100} />
                            <g.Li>
                                <g.Div className="content-share-detail">
                                    <SocialShare leftInfo={currentLeftTeam.beverage.name} rightInfo={currentRightTeam.beverage.name} />
                                    <MatchDetail
                                        timeTxt={this.formatUTCMatchDate(currentMatch.datetimeUTC, 'HH:mm z')}
                                        dateTxt={this.formatUTCMatchDate(currentMatch.datetimeUTC, 'DD/MM/YYYY')}
                                        stadiumTxt={`${currentStadium.name}, ${currentStadium.city}`}
                                        altTxt="" />
                                </g.Div>
                            </g.Li>
                            <TeamInCard
                                pic={`./images/beverages/${currentRightTeam.beverage.pic}`}
                                name={currentRightTeam.beverage.name}
                                minTxt={`${defaults.beverageAlcoholProof.min}º`}
                                maxTxt={`${defaults.beverageAlcoholProof.max}º`}
                                valueTxt={`${currentRightTeam.beverage.alcoholProof}º de alcohol`}
                                barPercent={(currentRightTeam.beverage.alcoholProof/defaults.beverageAlcoholProof.max)*100} />
                        </g.Ul>
                    </g.Div>                  
                </Swiper>)
    }
}

export default CardViews


// WEBPACK FOOTER //
// ./src/components/calendar/card-views-fragm.js